const loggers = {};
const levels = ["info", "log", "warn", "error"];

class Logger {
  constructor(name, level = "info") {
    this.name = name;
    this.entries = [];
    this.setLogLevel(level);
  }

  setLogLevel(level) {
    levels.forEach(function (fn, i) {
      let prefix = "[" + this.name + ":" + levels[i] + "]";

      this[fn] = function () {};

      if (window.console && i >= levels.indexOf(level) && level !== "none") {
        try {
          this[fn] = console[fn].bind(console, prefix);
        }
        catch (e) {
          // IE
          this[fn] = Function.prototype.bind.apply(console[fn], [prefix]);
        }
      }
    }, this);
  }

  getContext(name) {
    if (!loggers[name]) {
      loggers[name] = new Logger(name, "info");
    }

    return loggers[name];
  }
}

Logger.getContext = Logger.prototype.getContext;

module.exports = Logger;
